var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordyellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_8576",
    "data-name": "Groupe 8576",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.479,
    height: 15.105,
    viewBox: "0 0 36.479 15.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84001",
    "data-name": "Trac\\xE9 84001",
    d: "M572.234,676.626a.65.65,0,0,0-.889-.238l-1.277.737V675.65a.65.65,0,1,0-1.3,0v1.475l-1.277-.737a.65.65,0,1,0-.65,1.126l1.277.738-1.277.738a.65.65,0,0,0,.65,1.126l1.277-.737v1.475a.65.65,0,1,0,1.3,0v-1.475l1.277.737a.65.65,0,1,0,.65-1.126l-1.278-.738,1.278-.738a.65.65,0,0,0,.238-.888Zm0,0",
    transform: "translate(-551.562 -670.699)",
    fill: "#f7ba3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84002",
    "data-name": "Trac\\xE9 84002",
    d: "M469.485,676.626a.65.65,0,0,0-.889-.238l-1.277.737V675.65a.65.65,0,0,0-1.3,0v1.475l-1.277-.737a.65.65,0,1,0-.65,1.126l1.277.738-1.277.738a.65.65,0,0,0,.65,1.126l1.277-.737v1.475a.65.65,0,0,0,1.3,0v-1.475l1.277.737a.65.65,0,1,0,.65-1.126l-1.277-.738,1.277-.738a.65.65,0,0,0,.238-.888Zm0,0",
    transform: "translate(-457.723 -670.699)",
    fill: "#f7ba3f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84003",
    "data-name": "Trac\\xE9 84003",
    d: "M669.35,679.878a.651.651,0,0,0,.889.238l1.277-.737v1.475a.65.65,0,0,0,1.3,0v-1.475l1.277.737a.65.65,0,0,0,.65-1.126l-1.277-.738,1.277-.738a.65.65,0,0,0-.65-1.126l-1.277.737V675.65a.65.65,0,0,0-1.3,0v1.475l-1.277-.737a.65.65,0,1,0-.65,1.126l1.277.738-1.277.738a.65.65,0,0,0-.238.888Zm0,0",
    transform: "translate(-645.4 -670.699)",
    fill: "#f7ba3f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84004",
    "data-name": "Trac\\xE9 84004",
    d: "M440.917,633H429.451a.712.712,0,1,0,0,1.425h11.466a2.14,2.14,0,0,1,2.138,2.137v7.98a2.14,2.14,0,0,1-2.138,2.137H411.563a2.14,2.14,0,0,1-2.137-2.137v-7.98a2.14,2.14,0,0,1,2.137-2.137h11.475a.712.712,0,1,0,0-1.425H411.563A3.566,3.566,0,0,0,408,636.566v7.98a3.566,3.566,0,0,0,3.563,3.563h29.354a3.566,3.566,0,0,0,3.563-3.562v-7.98A3.566,3.566,0,0,0,440.917,633Zm0,0",
    transform: "translate(-408 -633.004)",
    fill: "#111136"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84005",
    "data-name": "Trac\\xE9 84005",
    d: "M440.917,633H429.451a.712.712,0,1,0,0,1.425h11.466a2.14,2.14,0,0,1,2.138,2.137v7.98a2.14,2.14,0,0,1-2.138,2.137H411.563a2.14,2.14,0,0,1-2.137-2.137v-7.98a2.14,2.14,0,0,1,2.137-2.137h11.475a.712.712,0,1,0,0-1.425H411.563A3.566,3.566,0,0,0,408,636.566v7.98a3.566,3.566,0,0,0,3.563,3.563h29.354a3.566,3.566,0,0,0,3.563-3.562v-7.98A3.566,3.566,0,0,0,440.917,633Zm0,0",
    transform: "translate(-408 -633.004)",
    fill: "#111136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordyellow);
export default __webpack_public_path__ + "static/media/Passwordyellow.f28b2722.svg";
export { ForwardRef as ReactComponent };